import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_license_requests_list = _resolveComponent("license-requests-list")!
  const _component_respond_to_negotiation = _resolveComponent("respond-to-negotiation")!
  const _component_actions_for_request_license = _resolveComponent("actions-for-request-license")!
  const _component_app_page = _resolveComponent("app-page")!

  return (_openBlock(), _createBlock(_component_app_page, {
    config: _ctx.config,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (!_ctx.showResponseModal)
          ? _withDirectives((_openBlock(), _createBlock(_component_license_requests_list, {
              key: 0,
              items: _ctx.requests,
              viewPerspective: _ctx.viewPerspective,
              onRespond: _ctx.openRequestModal
            }, null, 8, ["items", "viewPerspective", "onRespond"])), [
              [_vShow, !_ctx.loading]
            ])
          : _createCommentVNode("", true),
        (_ctx.showResponseModal)
          ? (_openBlock(), _createBlock(_component_respond_to_negotiation, {
              key: 1,
              show: _ctx.showResponseModal,
              data: _ctx.payLoad,
              "n-offer": _ctx.oferN,
              working: _ctx.controller.requests.responding.value,
              onRespond: _ctx.handleRequestModalResponse
            }, null, 8, ["show", "data", "n-offer", "working", "onRespond"]))
          : _createCommentVNode("", true),
        _createVNode(_component_actions_for_request_license, {
          action: _ctx.showModalActions,
          onCloseActions: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalActions = '')),
          onCounterOffer: _ctx.counterOffer,
          item: _ctx.payLoad?.item
        }, null, 8, ["action", "onCounterOffer", "item"])
      ])
    ]),
    _: 1
  }, 8, ["config", "loading"]))
}